import { tableViews } from '../../common/components/table/agGrid/tableViews';
import { setStateData } from '../../common/helpers/state';
import { useCommonStore } from '../../store/store';
import { getGrowthAnalysisTableSettingsByPeriod } from '../components/helpers/growthAnalysisHelpers';
import { getIntervalLastDates } from '../components/helpers/savedAgents';
import { contactToolTips, favoriteAgentTerms, growthAnalysisTooltips, listingProficiencyTooltips, overviewToolTips, activityToolTips } from '../constants/agentProductionConstants';
import { views } from '../constants/savedAgents';
import {
    useContactInfoAdditionalHeaders,
    useGrowthAnalysisAdditionalHeaders,
    useListingProfAdditionalHeaders,
    useOverviewAdditionalHeaders,
    useActivityAdditionalHeaders
} from './agGrid';
import { useSearchStore } from '../../store/store';
import { useSavedAgentsStore } from '../../store/store';
import { modules } from '../../constants';
import { getDateRangeText } from '../../common/helpers/titles';
import { agentProductionTerms as apt } from "../../constants";
import { useSearchResultsStore } from '../../store/searchResults/store';

export const useSavedAgentsTable = (state, setState) => {
    const {
        timeIntervals,
    } = useCommonStore(state => ({
        timeIntervals: state.timeIntervals,
    }));
    const searchStore = useSearchStore();
    const module = searchStore.selectedModule;
    const timePeriod = searchStore[module]?.loadedSearchCriteria?.timePeriod;
    const savedAgentsModule = modules.proficiencyMetrics.savedAgents;
    const { selectedList } = useSavedAgentsStore((state) => ({
        selectedList: state.selectedListByModule[savedAgentsModule]
    }));
    const { searchResults } = useSearchResultsStore(state => ({
        searchResults: state[module]?.searchResults
    }));

    const period = searchStore[module]?.loadedSearchCriteria?.timePeriod?.intervalType.toString();
    const searchPeriodDates = timeIntervals?.length && getIntervalLastDates(timeIntervals, period, timePeriod);
    const allMlsTransactionsDates = timeIntervals?.length && getIntervalLastDates(timeIntervals, apt.annually);
    const dateRangesText = {
        currentSearch: getDateRangeText(searchPeriodDates),
        allMls: getDateRangeText(allMlsTransactionsDates),
    };

    const setActivityColumns = (activityColumns) => {
        setStateData('activityColumns', activityColumns, setState);
    };

    const setOverviewColumns = (overviewColumns) => {
        setStateData('overviewColumns', overviewColumns, setState);
    };

    const setContactInfoColumns = (contactInfoColumns) => {
        setStateData('contactInfoColumns', contactInfoColumns, setState);
    };

    const setGrowthAnalysisColumns = (growthAnalysisColumns) => {
        setStateData('growthAnalysisColumns', growthAnalysisColumns, setState);
    };

    const setListingProfColumns = (listingProfColumns) => {
        setStateData('listingProfColumns', listingProfColumns, setState);
    };

    const allListPaginationConfig = {
        showPagination: true,
        paginationOptions: {
            sizePerPage: 100,
            sizePerPageList: [10, 20, 50, 100]
        }
    }

    const tableSettingsByView = {
        [views.overview]: {
            additionalTableHeaders: useOverviewAdditionalHeaders(
                state.overviewColumns,
                searchResults?.length,
                dateRangesText,
            ),
            tableTitleWithTooltips: overviewToolTips,
            columns: state.overviewColumns,
            setColumns: setOverviewColumns,
            tableView: {
                ...tableViews.overview,
                ...allListPaginationConfig
            },
            className: 'overview'
        },
        [views.contactInformation]: {
            additionalTableHeaders: useContactInfoAdditionalHeaders(
                state.contactInfoColumns,
                dateRangesText,
            ),
            tableTitleWithTooltips: contactToolTips,
            columns: state.contactInfoColumns,
            setColumns: setContactInfoColumns,
            tableView: {...tableViews.contactInformation,
                ...allListPaginationConfig
            },
            className: 'contact-information'
        },
        [views.growthAnalysis]: {
            additionalTableHeaders: useGrowthAnalysisAdditionalHeaders(
                state.growthAnalysisColumns ?? []
            ),
            tableTitleWithTooltips: growthAnalysisTooltips,
            columns: state.growthAnalysisColumns,
            setColumns: setGrowthAnalysisColumns,
            tableView: {...getGrowthAnalysisTableSettingsByPeriod(state.growthAnalysisPeriod),
                ...allListPaginationConfig
            },
            className: 'growth-analysis'
        },
        [views.listingProficiency]: {
            additionalTableHeaders: useListingProfAdditionalHeaders(
                state.listingProfColumns
            ),
            tableTitleWithTooltips: listingProficiencyTooltips,
            columns: state.listingProfColumns,
            setColumns: setListingProfColumns,
            tableView: {...tableViews.listingProficiency,
                ...allListPaginationConfig
            },
            className: 'listing-proficiency'
        },
        [views.activity]: {
            additionalTableHeaders: useActivityAdditionalHeaders(
                state.activityColumns,
                dateRangesText,
                state.activityRowData?.length,
            ),
            tableTitleWithTooltips: activityToolTips,
            columns: state.activityColumns,
            setColumns: setActivityColumns,
            tableView: tableViews.activity,
            className: 'activity'
        },
    };

    return tableSettingsByView;
};
